module.exports = __webpack_public_path__ + "static/media/header3.74def01d.png";